(() => {
  class RegularProduct extends HTMLElement {
    selectors = {
      customElement: 'regular-product',
      sliderFor: '.slider-product-main',
      sliderNav: '.slider-product-nav',
      sliderDots: '.js-regular-product__image-dots',
      galleryVideoWrapper: '.js-regular-product__video-wrapper, .js-productLanding__video-wrapper',
      galleryVideo: '.js-regular-product__video, .js-productLanding__video',
      faq: '.js-regular-product__faq',
      faqItem: '.regular-product__faq-item',
      faqItemHeader: '.regular-product__faq-item-question-wrapper',
      faqItemContentWrapper: '.regular-product__faq-item-answer',
      faqItemContent: '.regular-product__faq-item-answer-text',
      formQuantity: '.js-regular-product-quantity',
      formQuantityInput: '.js-regular-product-quantity-input',
      formQuantityHiddenInput: 'input[name="quantity"]',
      formProductIDHiddenInput: 'select[name="id"]',
      formAddToCartButton: '.js-regular-product-form-add-to-cart-button',
      scrollToProductButtons: '.js-scroll-to-product-button',
      scrollToReviewsButtons: '.js-scroll-to-reviews',
      okendoReviewsWidget: '.okendoReviewsWidget',
      upsellForm: '.js-regular-product-upsell-form',
      upsellFormButton: '.js-regular-product-upsell-form-button',
      giftProductInput: '.regular-product__form input[name="gift_item"]',
      giftRejectionInput: '.js-gift-rejection',
      customizeInput: '.regular-product-customize__options-item-list-input',
      customizeItem: '.regular-product-customize__options-item',
      customizeItemValue: '.regular-product-customize__options-item-header-value',
      regularProduct: '.regular-product',
      regularProductForm: '.regular-product__form',
      optionInputProduct: '.regular-product-customize__options-item-list-input',
      product__hiddenVariant: '.product__hiddenVariant',
      productColorSelector: 'product-color-selector',
      colorSelectorItem: '.product-color-selector__item-input',
    };

    modifiers = {
      galleryVideoWrapperActiveClass: 'regular-product__video-wrapper--active',
      faqItemActiveClass: 'regular-product__faq-item--active',
      v2Class: 'regular-product--v2',
    };

    elements = {
      galleryVideoWrapper: this.querySelectorAll(this.selectors.galleryVideoWrapper),
      faqItems: this.querySelectorAll(this.selectors.faqItem),
      quantity: this.querySelector(this.selectors.formQuantity),
      quantityInput: this.querySelector(this.selectors.formQuantityInput),
      quantityHiddenInput: this.querySelector(this.selectors.formQuantityHiddenInput),
      idHiddenInput: this.querySelector(this.selectors.formProductIDHiddenInput),
      addToCartButton: this.querySelector(this.selectors.formAddToCartButton),
      scrollToProductButtons: document.querySelectorAll(this.selectors.scrollToProductButtons),
      scrollToReviewsButtons: this.querySelectorAll(this.selectors.scrollToReviewsButtons),
      okendoReviewsWidget: document.querySelector(this.selectors.okendoReviewsWidget),
      upsellFormButtons: this.querySelectorAll(this.selectors.upsellFormButton),
      customizeInputs: this.querySelectorAll(this.selectors.customizeInput)
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    };

    disconnectedCallback() {
      this.destroy();
    };

    init = () => {
      this.initSliders();
      this.initListeners();
      this.syncQuantityBounds();
    }

    destroy = () => {
      this.destroySliders();
      this.removeListeners();
    }

    initSliders = () => {
      if (this.querySelector(this.selectors.sliderNav)) {
        const sliderForSoftSlidesToShowDesktop = this.querySelector(this.selectors.sliderNav).childElementCount > 6 ? 6 : this.querySelector(this.selectors.sliderNav).childElementCount - 1;
        const sliderForSoftSlidesToShowMobile  = this.querySelector(this.selectors.sliderFor).childElementCount > 6 ? 6 : this.querySelector(this.selectors.sliderFor).childElementCount - 1;

        $(this.selectors.sliderNav).slick({
          slidesToShow: sliderForSoftSlidesToShowDesktop,
          slidesToScroll: 1,
          asNavFor: $(this.selectors.sliderFor),
          dots: false,
          arrows: false,
          focusOnSelect: true,
          responsive: [{
            breakpoint: 640,
            settings: {
              slidesToShow: sliderForSoftSlidesToShowMobile
            }
          }]
        });
      }

      const sliderForOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: $(this.selectors.sliderNav).length > 0 ? this.selectors.sliderNav : null
      };

      // The dots container only exists for the Enamel look, so every other
      // template gets the object above untouched — the keys are added, not set
      // to `undefined`, because "slick is built on `$.extend` and jQuery skips
      // undefined" is too fine a thread to hang five live PDPs on.
      //
      // The breakpoint is 641, not 640: slick applies a block while the window
      // is *narrower* than the number, which is what lines it up with the
      // stylesheet's `max-width: 640`.
      const dotsContainer = this.querySelector(this.selectors.sliderDots);

      if (dotsContainer) {
        sliderForOptions.appendDots = $(dotsContainer);
        sliderForOptions.responsive = [{
          breakpoint: 641,
          settings: { dots: true }
        }];
      }

      $(this.selectors.sliderFor).slick(sliderForOptions);
    }

    destroySliders = () => {
      $(this.selectors.sliderFor).slick('destroy');
      $(this.selectors.sliderNav).slick('destroy');
    }

    slideChange = () => {
      if (this.querySelector(`.${this.modifiers.galleryVideoWrapperActiveClass}`)) {
        this.toggleVideo(null, this.querySelector(`.${this.modifiers.galleryVideoWrapperActiveClass}`));
      }
    }

    toggleVideo = (event, wrapper) => {
      const currentWrapper = wrapper ? wrapper : event.currentTarget;
      const currentVideo = currentWrapper.querySelector(this.selectors.galleryVideo);

      if (!currentVideo) return;

      if (currentVideo.paused) {
        currentVideo.play();
        currentWrapper.classList.add(this.modifiers.galleryVideoWrapperActiveClass);

        currentVideo.addEventListener('ended', function() {
          currentVideo.pause();
          currentWrapper.classList.remove(this.modifiers.galleryVideoWrapperActiveClass);
        });
      } else {
        currentVideo.pause();
        currentWrapper.classList.remove(this.modifiers.galleryVideoWrapperActiveClass);
      }
    }

    faqToggle = (e) => {
      const target = e.target;
      const faq = target.closest(this.selectors.faq);
      const clickedItem = target.closest(this.selectors.faqItem);
      const activeItem = faq.querySelector(`.${this.modifiers.faqItemActiveClass}`);

      if (activeItem) {
        activeItem.classList.remove(this.modifiers.faqItemActiveClass);
        const contentWrapper = activeItem.querySelector(this.selectors.faqItemContentWrapper);

        if (contentWrapper) contentWrapper.style.maxHeight = '0';
      }

      if (clickedItem && clickedItem !== activeItem) {
        clickedItem.classList.add(this.modifiers.faqItemActiveClass);
        const content = clickedItem.querySelector(this.selectors.faqItemContent);
        const contentWrapper = clickedItem.querySelector(this.selectors.faqItemContentWrapper);

        if (content && contentWrapper) {
          contentWrapper.style.maxHeight = content.scrollHeight + 'px';
        }
      }
    };

    updateButtonPrice = (quantity) => {
      const button = this.elements.addToCartButton;
      if (!button) return;

      const template = button.dataset.buttonTemplate;
      if (!template || !template.includes('[price]')) return;

      const basePrice = parseInt(button.dataset.basePrice, 10);
      if (!basePrice) return;

      const totalPrice = basePrice * quantity;
      const formattedPrice = Shopify.formatMoney(totalPrice, `${selectedCurrency}{{amount}}`).replace(/\.00$/, '');
      button.querySelector('.regular-product__form-button-text').textContent = template.replace('[price]', formattedPrice);
    }

    changeQuantity = (quantity) => {
      const quantityHiddenInput = this.elements.quantityHiddenInput;

      quantityHiddenInput.value = quantity;
      this.updateButtonPrice(quantity);
      this.syncQuantityBounds();
    }

    syncQuantityBounds = () => {
      const root = this.querySelector(this.selectors.regularProduct);

      if (!root || !root.classList.contains(this.modifiers.v2Class)) return;

      const input = this.elements.quantityInput;
      const quantity = this.elements.quantity;

      if (!input || !quantity) return;

      quantity.dataset.atMin = +input.value <= 1;
      quantity.dataset.atMax = +input.value >= +input.max;
    }

    changeQuantityNumber = (e) => {
      const target = e.target;
      const quantityInput = target.closest(this.selectors.formQuantity).querySelector(this.selectors.formQuantityInput);
      const max = quantityInput.max;

      if (target.dataset.quantityButton === 'decrease') {
        if (+quantityInput.value == 1) return;

        quantityInput.value = +quantityInput.value - 1;

        this.changeQuantity(quantityInput.value);
      } else if (target.dataset.quantityButton === 'increase' && +quantityInput.value < max) {
        quantityInput.value = +quantityInput.value + 1;

        this.changeQuantity(quantityInput.value);
      }
    }

    addToCart = async () => {
      const quantityHiddenInput = this.elements.quantityHiddenInput;
      const idHiddenInput = this.elements.idHiddenInput;
      const items = [];
      const giftProductInput = this.querySelector(this.selectors.giftProductInput);
      const giftRejectionInput = this.querySelector(this.selectors.giftRejectionInput);
      const giftReject = giftRejectionInput && giftRejectionInput.checked ? true : false;

      const mainItem = {
        id: parseInt(idHiddenInput.value),
        quantity: parseInt(quantityHiddenInput.value)
      };

      if (giftProductInput && !giftReject) {
        mainItem.properties = {
          'gift_product_id': parseInt(giftProductInput.value)
        };
      }

      if (giftReject) {
        mainItem.properties = {
          '_without_gift': true
        };
      }

      const cartUpdate = new Event('cartUpdate');
      items.push(mainItem);

      if(giftProductInput && !giftReject) {
        items.push({
          id: parseInt(giftProductInput.value),
          quantity: parseInt(quantityHiddenInput.value)
        });
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) return;

        document.querySelector('body').dispatchEvent(cartUpdate);
      } catch (error) {
        console.error('Add to cart error:', error);
      }
    };

    scrollToProduct = () => {
      this.scrollIntoView({block: "start", behavior: "smooth"});
    };

    scrollToReviews = () => {
      const okendoReviewsWidget = this.elements.okendoReviewsWidget;

      if (okendoReviewsWidget) {
        okendoReviewsWidget.scrollIntoView({block: "start", behavior: "smooth"});
      }
    };

    upsellAddToCart = async (event) => {
      const currentForm = event.target.closest(this.selectors.upsellForm);
      const currentID = currentForm.querySelector("[name='id']").value;
      const giftProductInput = currentForm.querySelector("[name='gift_item']");
      const items = [];
      const mainItem = {
        id: parseInt(currentID),
        quantity: 1
      };

      if (giftProductInput) {
        mainItem.properties = {
          'gift_product_id': parseInt(giftProductInput.value)
        };
      }

	    const cartUpdate = new Event('cartUpdate');

      items.push(mainItem);

      if(giftProductInput) {
        items.push({
          id: parseInt(giftProductInput.value),
          quantity: 1
        });
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) return;

        document.querySelector('body').dispatchEvent(cartUpdate);
      } catch (error) {
        console.error('Add to cart error:', error);
      }
    }

    updateCustomizeInput = (event) => {
      const currentItem = event.target.closest(this.selectors.customizeItem);

      if (currentItem) {
        const currentItemValue = currentItem.querySelector(this.selectors.customizeItemValue);

        if (currentItemValue) {
          currentItemValue.textContent = event.target.dataset.title;
        }
      }
    }

    getSelectedVariant = (event) => {
      const productColorSelector = this.querySelector(this.selectors.productColorSelector);
      const selects = this.querySelectorAll(this.selectors.optionInputProduct);
      let selectedValues = [];

      selects.forEach((element) => {
        if (element.checked) {
          selectedValues.push(element.value);
        }
      });

      if (productColorSelector) {
        const checkedColor = productColorSelector.querySelector(`${this.selectors.colorSelectorItem}:checked`);

        if (checkedColor) {
          selectedValues.push(checkedColor.value);
        }
      }

      const options = this.querySelectorAll(this.selectors.product__hiddenVariant);
      const variantOption = Array.from(options).find(option => {
        const nameParts = option.dataset.variantName.split('/').map(stringPart => stringPart.trim());

        return selectedValues.every(val => nameParts.includes(val));
      });

      if (variantOption) {
        variantOption.selected = true;
      }
    }

    initListeners = () => {
      this.elements.galleryVideoWrapper.forEach(wrapper => {
        wrapper.addEventListener('click', this.toggleVideo);
      });

      $(this.selectors.sliderFor).on('afterChange', this.slideChange);

      this.elements.faqItems.forEach(item => {
        item.addEventListener('click', this.faqToggle);
      });

      this.elements.quantity.addEventListener('click', this.changeQuantityNumber);
      this.elements.addToCartButton.addEventListener('click', this.addToCart);

      this.elements.scrollToProductButtons.forEach(button => { button.addEventListener('click', this.scrollToProduct); });
      this.elements.scrollToReviewsButtons.forEach(button => { button.addEventListener('click', this.scrollToReviews); });
      this.elements.upsellFormButtons.forEach(button => { button.addEventListener('click', (event) => { event.preventDefault(); this.upsellAddToCart(event); }); });
      this.elements.customizeInputs.forEach(input => { input.addEventListener('change', this.updateCustomizeInput); });
      this.elements.customizeInputs.forEach(input => { input.addEventListener('change', this.getSelectedVariant); });
    }

    removeListeners = () => {
      this.elements.galleryVideoWrapper.forEach(wrapper => {
        wrapper.removeEventListener('click', this.toggleVideo);
      });

      $(this.selectors.sliderFor).off('afterChange', this.slideChange);

      this.elements.faqItems.forEach(item => {
        item.removeEventListener('click', this.faqToggle);
      });

      this.elements.quantity.removeEventListener('click', this.changeQuantityNumber);
      this.elements.addToCartButton.removeEventListener('click', this.addToCart);
      this.elements.scrollToProductButtons.forEach(button => { button.removeEventListener('click', this.scrollToProduct); });
      this.elements.scrollToReviewsButtons.forEach(button => { button.removeEventListener('click', this.scrollToReviews); });
      this.elements.upsellFormButtons.forEach(button => { button.removeEventListener('click', (event) => { event.preventDefault(); this.upsellAddToCart(event); }); });
      this.elements.customizeInputs.forEach(input => { input.removeEventListener('change', this.updateCustomizeInput); });
      this.elements.customizeInputs.forEach(input => { input.removeEventListener('change', this.getSelectedVariant); });
    }
  }

  if (!customElements.get('regular-product')) {
    customElements.define('regular-product', RegularProduct);
  }
})();
